import { render, staticRenderFns } from "./VButtonDropdown.vue?vue&type=template&id=0d6eaf4f"
import script from "./VButtonDropdown.vue?vue&type=script&lang=js"
export * from "./VButtonDropdown.vue?vue&type=script&lang=js"
import style0 from "./VButtonDropdown.vue?vue&type=style&index=0&id=0d6eaf4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports